import React, { useState } from "react";
import EmailButton from "./Email/EmailButton";
import { Product } from "~/common/Store/models/ProductListing";
import { UserState } from "~/common/Store/models/RootReadonly";
import { PurchasingGroupSelectedProduct } from "~/productListing/PurchasingGroupPage/purchasingGroupPageResult";

interface Props {
  user: UserState;
  product: Product;
  isProductDiscontinued?: boolean;
  setPurchasingGroupItemsSelected: (
    selectedProduct: PurchasingGroupSelectedProduct,
  ) => void;
}

const PurchasingGroupMinimumQuantityView = ({
  user,
  product,
  isProductDiscontinued,
  setPurchasingGroupItemsSelected,
}: Props) => {
  const { isInStock } = product;
  const [quantity, setQuantity] = useState(0);

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    let qty = Number(event.target.value);

    qty = qty > 0 ? qty : 0;

    setQuantity(qty);
    if (setPurchasingGroupItemsSelected) {
      setPurchasingGroupItemsSelected({
        itemNumber: product.grouping ? product.originalId : product.itemNumber,
        product,
        quantity: qty,
      });
    }
  };

  const handleQuantityUpButtonChange = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    const newValue = Number(quantity) + 1;
    setQuantity(newValue);
    if (setPurchasingGroupItemsSelected) {
      setPurchasingGroupItemsSelected({
        itemNumber: product.grouping ? product.originalId : product.itemNumber,
        product,
        quantity: newValue,
      });
    }
  };

  const handleQuantityDownButtonChange = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    if (quantity > 0) {
      const newValue = Number(quantity) - 1;
      setQuantity(newValue);
      if (setPurchasingGroupItemsSelected) {
        setPurchasingGroupItemsSelected({
          itemNumber: product.grouping
            ? product.originalId
            : product.itemNumber,
          product,
          quantity: newValue,
        });
      }
    }
  };

  return (
    <div className="add-to-cart">
      {!isInStock && !isProductDiscontinued && (
        <EmailButton
          product={product}
          itemNumber={product.itemNumber}
          user={user}
        />
      )}
      {isInStock && (
        <div className="qty">
          <label>Quantity</label>
          <div className="num-spinner">
            <button
              className="btn btn-mini btn-light icon-down-micro quantityButton rounded-r-none h-[28px]"
              onClick={handleQuantityDownButtonChange}
              type="button"
              data-no-jquery
            />
            <input
              className="input-mini mb-0 rounded-none border-x-0"
              type="text"
              value={quantity}
              data-no-jquery
              onChange={handleQuantityChange}
            />
            <button
              className="btn btn-mini btn-light icon-up-micro quantityButton rounded-l-none h-[28px]"
              onClick={handleQuantityUpButtonChange}
              type="button"
              data-no-jquery
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchasingGroupMinimumQuantityView;
